// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".DateHeader p[data-v-6ce4f824]{margin:0}.DateHeader[data-v-6ce4f824]{margin-top:.3125rem;color:grey}", ""]);
// Exports
module.exports = exports;
